module.exports = __webpack_public_path__ + "static/media/FXgAX8OagAACUHE.4ea3d245.jpg";